import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AlertButtonColor } from "@obg/mat.ui.core";
import { CommonResponsibleGamingSelector } from "@obg/ngx.common";
import { AbstractTranslatableAlertService, SessionAction } from "@obg/ngx.core";
import { CoreContentState, TranslationGroup } from "@obg/ngx.core.content";
import { exhaustMap, filter, switchMap } from "rxjs/operators";

const SESSION_TIME_LIMIT_ALERT_ID = "SESSION_TIME_LIMIT_ALERT_ID";
@Injectable({
	providedIn: "root",
})
export class SessionTimeLimitService {
	private isAlertOpened = false;

	constructor(
		private responsibleGamingSelector: CommonResponsibleGamingSelector,
		private sessionAction: SessionAction,
		private store: Store<CoreContentState>,
		private alertService: AbstractTranslatableAlertService
	) {}

	initialize$() {
		return this.store.pipe(
			select(this.responsibleGamingSelector.getSessionDuration()),
			filter((sessionDuration) => sessionDuration > 0 && !this.isAlertOpened),
			exhaustMap((sessionDuration) => this.sessionDurationAlert$(sessionDuration!))
		);
	}

	private sessionDurationAlert$(sessionDuration: number) {
		this.isAlertOpened = true;
		return this.alertService
			.open$(
				{
					id: SESSION_TIME_LIMIT_ALERT_ID,
					testId: SESSION_TIME_LIMIT_ALERT_ID,
					title: "responsible-gaming.session-time-limit.popup-title",
					message: "responsible-gaming.session-time-limit.popup-body",
					buttons: [
						{
							color: AlertButtonColor.Primary,
							text: "responsible-gaming.session-time-limit.log-out",
							handler: () => this.store.dispatch(this.sessionAction.logout()),
						},
						{
							text: "general.ok",
						},
					],
					hideClose: true,
					preserveOnLogout: true,
					dialogConfig: {
						disableClose: true,
					},
					mustBeInteracted: true,
					onClose: () => (this.isAlertOpened = false),
				},
				[TranslationGroup.Common],
				{ sessionDuration }
			)
			.pipe(switchMap((ref) => ref.afterClosed()));
	}
}
